import { render, staticRenderFns } from "./listFoods.vue?vue&type=template&id=18140c91&scoped=true&"
import script from "./listFoods.vue?vue&type=script&lang=js&"
export * from "./listFoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18140c91",
  null
  
)

export default component.exports